import { PropertyProfile } from "../property-profile/property-profile";

export class OwnerProfile
{
	ownerProfileId: number;
	ownerProfileDate: Date;
	anniversaryDate: Date;
	propertyProfileVOList: PropertyProfile[];
	portalAccessBasic: any;
	contractSignDate: Date;
	birthDate: Date;
	listingStatus: any;
	emailAddress: any;
	// constructor(ownerProfileId: number, ownerProfileDate: Date,anniversaryDate: Date,propertyProfileVOList: PropertyProfile[]) {
    //     this.ownerProfileId = ownerProfileId;
    //     this.ownerProfileDate = ownerProfileDate;
	// 	this.anniversaryDate = anniversaryDate;
	// 	this.propertyProfileVOList = propertyProfileVOList;
    // }
	mobilePhone: string;
	phone2: string;
	fullName: string;
	firstName: string;
	lastName: string;
	subjAdrStreet: string;
	mailAdrStreet: string;
	mailAdrStreet2: string;
	mailAdrCity: string;
	mailAdrState: string;
	mailAdrCountry: string;
	mailAdrPostalCode: string;
	ownerUserId: any;
}
